import React from 'react'

export default function HeightSpacer() {
  return (
    <>
        <div style={{backgroundColor:'black', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(3, 3, 3)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(6, 6, 6)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(10, 10, 10)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(14, 14, 14)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(22, 22, 22)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(30, 30, 30)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(38, 38, 38)', minHeight: '3px', width: '100%'}}/> {/* CENTER */}
        <div style={{backgroundColor:'rgb(30, 30, 30)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(22, 22, 22)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(14, 14, 14)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(10, 10, 10)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(6, 6, 6)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'rgb(3, 3, 3)', minHeight: '3px', width: '100%'}}/>
        <div style={{backgroundColor:'black', minHeight: '3px', width: '100%'}}/>
    </>
    
  )
}
